module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ext-form', {
    attrs: {
      "formData": _vm.formData,
      "submitProxy": _vm.submitProxy,
      "loadProxy": _vm.loadProxy,
      "extraData": _vm.extraData
    }
  }, [_c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('name')
    },
    attrs: {
      "label": "Название",
      "feedback": _vm.errors.first('name')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name),
      expression: "formData.name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name"
    },
    domProps: {
      "value": (_vm.formData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('cost')
    },
    attrs: {
      "label": "Стоимость",
      "feedback": _vm.errors.first('cost')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.cost),
      expression: "formData.cost"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cost"
    },
    domProps: {
      "value": (_vm.formData.cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.cost = $event.target.value
      }
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48c1ecc9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/CourseForm.vue
// module id = 228
// module chunks = 1